var map = {
	"./10crore/index.css": [
		1334,
		183
	],
	"./24betting/index.css": [
		1335,
		185
	],
	"./appletvlike/index.css": [
		1336,
		193
	],
	"./bitomania/index.css": [
		1337,
		194
	],
	"./dailyexch/index.css": [
		1338,
		195
	],
	"./dailyexch2/index.css": [
		1339,
		196
	],
	"./fairway/index.css": [
		1340,
		186
	],
	"./netflixlike/index.css": [
		1341,
		197
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 948;
module.exports = webpackAsyncContext;